import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import QrReader from 'react-qr-reader'
import Alert from 'Shared/Alert';

import { stateMapping, dispatchMapping } from './mapping';
let timer = null;

const ScanView = (props) => {
  const [code, setCode] = useState('');
  const { onSubmitCode, showSelector, alert, loading, scanner, onToggleScanner } = props;
  const [now, updateNow] = useState(new Date().toTimeString().substr(0, 8));

  useEffect(() => {
    if (!timer) {
      timer = setInterval(() => {
        updateNow(new Date().toTimeString().substr(0, 8));
      }, 1000);
    }
    return () => {
      clearInterval(timer);
      timer = null;
    };
  });

  const onScan = (data) => {
    if (!data) return;

    setCode(data);
    onSubmitCode(props)(data);
  };

  return (
    <div className="d-flex flex-fill justify-content-around flex-column align-items-center padding-bottom-xl">
      <div className="container">
        <div className="card shadow">
          <div className="card-header">
            <h2 className="float-right">{now}</h2>
            <h2>Tools</h2>
          </div>
          <div className="card-body text-center">
            <Alert alert={alert} />
            <div className="push-top-lg1">
              <button
                type="button"
                className={`btn btn-${scanner ? 'primary' : 'light'} btn-block`}
                onClick={() => onToggleScanner(!scanner)}
              >
                {!scanner && 'Scan QR codes using camera'}
                {scanner && 'Disable Camera'}
              </button>
            </div>
            {!loading && scanner && (
              <div className="push-top-sm">
                <QrReader
                  delay={300}
                  onError={console.error}
                  onScan={onScan}
                />
              </div>
            )}
            <div className="push-top-lg">
              <label className="control-label" style={{ fontSize: '1.5rem' }}>
                {'Please enter tool\'s special digit'}
              </label>
              <input
                type="text"
                className="form-control text-center"
                style={{ fontSize: '1.5rem' }}
                value={code}
                onChange={e => setCode(e.target.value)}
              />
            </div>
            <div className="push-top-lg text-center">
              <button
                type="button"
                className="btn btn-primary btn-wide w-50 m-auto"
                onClick={() => onSubmitCode(props)(code)}
                disabled={!code}
              >
                {'Submit'}
              </button>
            </div>
          </div>
          <div className="card-footer text-center">
            <button
              type="button"
              className="btn btn-link text-muted"
              onClick={() => showSelector()}
            >
              {'Go back'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect(stateMapping, dispatchMapping)(ScanView);
